import React from "react";
import { Check, X, HelpCircle } from "lucide-react";

export function AvailabilityBadge({ available, extension = ".com", size = "md" }) {
  const pad = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-[12px]";
  if (available === true) {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full font-semibold bg-success-bg text-success ${pad}`} data-testid="availability-badge-available">
        <Check size={13} strokeWidth={2.5} /> {extension} available
      </span>
    );
  }
  if (available === false) {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full font-semibold bg-danger-bg text-danger ${pad}`} data-testid="availability-badge-taken">
        <X size={13} strokeWidth={2.5} /> {extension} taken
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-semibold bg-canvas-alt text-ink-subtle ${pad}`} data-testid="availability-badge-unknown">
      <HelpCircle size={13} strokeWidth={2.5} /> unknown
    </span>
  );
}
